// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2Caoy","right":"styles_right__2z7Ot"};